import { Component, OnInit } from '@angular/core';
import config from './shared/data/config.json';
import networks from './shared/data/networks.json';
import { NetworkModel } from './shared/models/network.model';
import { BlocknativeService } from './shared/services/blocknative.service';
import { TokenService } from './shared/services/contracts/token.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  isCollapsed = true;
  balanceHovered = false;
  availableNetworks: NetworkModel[] = networks;

  constructor(
    public bncService: BlocknativeService,
    public tokenService: TokenService
  ) {}

  ngOnInit(): void {
    // this.bncService.init();
  }

  logout(): void {
    this.bncService.logout();
  }

  setBalanceHovered(value: boolean): void {
    if (this.bncService.wallet?.label === 'MetaMask') {
      this.balanceHovered = value;
    }
  }

  addToken(): void {
    const ethereum = (window as any).ethereum;
    if (ethereum && localStorage.getItem('SELECTED_WALLET') === 'MetaMask') {
      ethereum.request({
        method: 'wallet_watchAsset',
        params: {
          type: 'ERC20', // Initially only supports ERC20, but eventually more!
          options: {
            address: config.networks[0].tokenAddress, // The address that the token is at.
            symbol: config.tokenName, // A ticker symbol or shorthand, up to 5 chars.
            decimals: 12, // The number of decimals in the token
            image: `${window.location.origin}/assets/images/defactor-logo.png`, // A string url of the token logo
          },
        },
      });
    }
  }

  onNetworkChange(network: NetworkModel): void {
    this.bncService.changeNetwork(network);
  }

  get isLoading(): boolean {
    return !this.bncService.address || !this.bncService.wallet;
  }

  get connectedNetwork(): NetworkModel {
    return (
      this.availableNetworks.find(
        (network) =>
          Number(network.params[0].chainId) === this.bncService.networkId
      ) || this.availableNetworks[0]
    );
  }

  get tokenName(): any {
    return config.tokenName;
  }
}
